module.exports = __webpack_public_path__ + "static/media/cloud-training.96b2148f.png";